import { render, staticRenderFns } from "./clientStatusPicker.vue?vue&type=template&id=5fe19c04&scoped=true&"
import script from "./clientStatusPicker.vue?vue&type=script&lang=js&"
export * from "./clientStatusPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe19c04",
  null
  
)

export default component.exports